import { render, staticRenderFns } from "./IRGroupFactsAndFiguresPage.vue?vue&type=template&id=10f28a62"
import script from "./IRGroupFactsAndFiguresPage.vue?vue&type=script&lang=js"
export * from "./IRGroupFactsAndFiguresPage.vue?vue&type=script&lang=js"
import style0 from "./IRGroupFactsAndFiguresPage.vue?vue&type=style&index=0&id=10f28a62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports